export class StockStatementModel{
    fgInfo : StockStatementProductInfo[]
    jumbleInfo:StockStatementProductInfo[]
    g2Info : StockStatementProductInfo[]
    otherProdutsInfo: StockStatementProductInfo[]
    totalProduction: number
    totalQtyInKgs : number
    constructor(fgInfo : StockStatementProductInfo[],jumbleInfo:StockStatementProductInfo[],g2Info : StockStatementProductInfo[],otherProdutsInfo: StockStatementProductInfo[],totalProduction: number,totalQtyInKgs:number){
        this.fgInfo = fgInfo
        this.jumbleInfo = jumbleInfo
        this.g2Info = g2Info
        this.otherProdutsInfo = otherProdutsInfo
        this.totalProduction = totalProduction
        this.totalQtyInKgs = totalQtyInKgs
    }

}

export class StockStatementProductInfo{
    product: string;
    gradesInfo: StockStatementGradesInfo[]

    constructor(product:string,gradesInfo:StockStatementGradesInfo[]){
        this.product = product
        this.gradesInfo = gradesInfo

    }
}

export class  StockStatementGradesInfo{
    grade:string
    masterCartons : number
    loosePouches : number

    constructor(grade:string, masterCartons : number,loosePouches : number){
        this.grade = grade
        this.masterCartons = masterCartons
        this.loosePouches = loosePouches
    }
}